/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/objects'
import * as ActionTypes from '@src/redux/actionTypes/objects.action.types'
import type { ObjectDetailInfo } from '@src/endpoints/services/graphQueryMgr.service'
import type { InfoDetailsResult } from '@src/utils/resource.utils'
import { defaultState, ObjectDetailsState } from './default.state'

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): ObjectDetailsState {
  switch (action.type) {
    case ActionTypes.CHANGE_DETAILS_STATE: {
      const { payload } = action
      return {
        ...state,
        ...payload
      }
    }
    case ActionTypes.DETAILS_SERVER_ERRORS: {
      const { stateProps = {} as ObjectDetailsState } = action?.payload
      return {
        ...state,
        ...stateProps
      }
    }

    case ActionTypes.CLEANER_STAT: {
      return {
        ...state,
        [action.payload.stat]: defaultState[action.payload.stat]
      }
    }

    case ActionTypes.DISPOSE_DETAILS: {
      return {
        ...state,
        selectedGraphView: defaultState.selectedGraphView,
        selectedTile: defaultState.selectedTile,
        graph: defaultState.graph,
        objectInfo: defaultState.objectInfo,
        table: defaultState.table,
        users: defaultState.users,
        admin: defaultState.admin,
        groups: defaultState.groups,
        roles: defaultState.roles,
        services: defaultState.services,
        policies: defaultState.policies,
        alerts: defaultState.alerts,
        networks: defaultState.networks,
        isPendingGraph: defaultState.isPendingGraph
      }
    }

    case ActionTypes.REQUEST_PENDING_GRAPH: {
      return {
        ...state,
        isPendingGraph: action.payload.isPending
      }
    }
    case ActionTypes.GET_OBJECT_DETAILS_STATS_DATA: {
      const {
        data = {} as ObjectDetailInfo,
        objectInfo = {} as InfoDetailsResult
      } = action?.payload
      const { admin_cnt, user_cnt, group_cnt, role_cnt, svc_count } = data
      return {
        ...state,
        objectInfo: {
          ...state.objectInfo,
          ...objectInfo
        },
        admin: admin_cnt,
        users: user_cnt,
        groups: group_cnt,
        roles: role_cnt,
        services: svc_count
      }
    }

    case ActionTypes.GET_OBJECT_DETAILS_GRAPH_DATA: {
      return {
        ...state,
        graph: action.payload.graph,
        isPendingGraph: false
      }
    }

    case ActionTypes.GET_OBJECT_DETAILS_TABLE_DATA: {
      return {
        ...state,
        table: action.payload.table || state.table,
        selectedTile: action.payload.selectedTile,
        isPending: false
      }
    }

    default: {
      return state
    }
  }
}
